import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkyListColumnSelectorActionComponent } from './list-column-selector-action.component';
import { SkyResourcesModule } from '../resources';
import { SkyModalModule } from '../modal';
import { SkyListSecondaryActionsModule } from '../list-secondary-actions';


export class SkyListColumnSelectorActionModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyListColumnSelectorActionComponent
  ],
  imports: [
    CommonModule,
    SkyResourcesModule,
    SkyModalModule,
    SkyListSecondaryActionsModule
  ],
  exports: [
    SkyListColumnSelectorActionComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
